import { Button, Form } from 'antd';
import type { FormInstance } from 'rc-field-form';

import type { BulkEditFormValues } from 'app/typings/bulkEdit';

import type { FieldsDisplayValues } from '../RoomBulkEdit';
import styles from '../RoomBulkEdit.module.scss';

type RoomBulkEditFooterProps = {
  handleClose: () => void;
  openValues: FieldsDisplayValues;
  form: FormInstance<BulkEditFormValues>;
  isLoading: boolean;
};

export const RoomBulkEditFooter = ({
  handleClose,
  openValues,
  form,
  isLoading,
}: RoomBulkEditFooterProps) => {
  const allFieldsDisabled =
    !openValues.price &&
    !openValues.stock &&
    !openValues.discount &&
    !openValues.discountPrice;

  const isDisabled =
    allFieldsDisabled ||
    !form.isFieldsTouched(['startDate', 'endDate'], true) ||
    !!form.getFieldsError().filter(({ errors }) => errors.length).length;

  return (
    <div className={styles.bulkEditFooter}>
      <Form.Item shouldUpdate>
        {() => (
          <>
            <Button size="large" type="ghost" onClick={handleClose} key="back">
              Cancel
            </Button>
            <Button
              key="save"
              size="large"
              type="primary"
              htmlType="submit"
              disabled={isDisabled}
              loading={isLoading}
            >
              Save
            </Button>
          </>
        )}
      </Form.Item>
    </div>
  );
};
